import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withKeys as _withKeys, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73818028"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "login-form" }
const _hoisted_3 = { class: "white" }
const _hoisted_4 = { class: "inputs" }
const _hoisted_5 = { class: "white" }
const _hoisted_6 = {
  key: 1,
  class: "or"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "or-text" }, "or", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]

import { inject, computed, ref } from 'vue'
import Input from '@/components/Input.vue'
import TransparentButton from '@/mobile/src/components/TransparentButton.vue'
import { loginAndRedirect, postLoginActions } from '@/mobile/src/services/auth'
import AppVersion from '@/mobile/src/components/AppVersion.vue'
import { samlLogin } from '@/mobile/src/utils/capacitor'
import { LoginMainPkey, LoginMainProvided } from '@/mobile/src/types/auth'

interface Props {
    domain: string
    disableEmailLogin: number
    samlSsoName?: string
    samlSsoUrl?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'StandardLogin',
  props: {
    domain: { default: '' },
    disableEmailLogin: { default: 0 },
    samlSsoName: { default: '' },
    samlSsoUrl: { default: '' }
  },
  setup(__props: any) {

const email = ref('')
const password = ref('')

const props = __props

const hasOtherOptions = computed(() => {
    return !!props.samlSsoUrl
})

const { persistCredentials } = inject(LoginMainPkey) as LoginMainProvided

function onUpdateEmail(newEmail: string) {
    email.value = newEmail
}

function onUpdatePassword(newPass: string) {
    password.value = newPass
}

async function onLogin() {
    if (!/^\w+$/.test(props.domain)) {
        alert('Invalid domain')
        return
    }
    persistCredentials({ email: email.value, password: password.value })
    await loginAndRedirect(props.domain, email.value, password.value)
}

async function onSamlSSO() {
    if (!props.samlSsoUrl) {
        return
    }
    const response = await samlLogin(props.samlSsoUrl, props.domain)
    if (!response) {
        return
    }
    const urlParams = new URLSearchParams(response)
    await postLoginActions(props.domain, urlParams.get('token'))
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, "Domain: " + _toDisplayString(_ctx.domain), 1),
      (!_ctx.disableEmailLogin)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(Input, {
                title: "Email",
                type: "email",
                placeholder: "Email",
                regex: /.+@.+\..+/,
                required: true,
                "err-msg": 'Valid email is required',
                "model-value": email.value,
                "onUpdate:modelValue": onUpdateEmail
              }, null, 8, ["model-value"]),
              _createElementVNode("div", {
                onKeyup: _cache[0] || (_cache[0] = _withKeys(() => _ctx.$refs.btnLogin.onClick(), ["enter"]))
              }, [
                _createVNode(Input, {
                  title: "Password",
                  placeholder: "Password",
                  type: "password",
                  required: true,
                  "err-msg": 'Invalid Password',
                  "model-value": password.value,
                  "onUpdate:modelValue": onUpdatePassword
                }, null, 8, ["model-value"])
              ], 32)
            ]),
            _createVNode(TransparentButton, {
              ref: "btnLogin",
              class: "btn-login",
              text: "Login",
              click: onLogin
            }, null, 512)
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("p", _hoisted_5, [
        _createTextVNode(" Back to "),
        _createVNode(_component_RouterLink, {
          class: "find-login white",
          to: { name: 'findlogin' },
          replace: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode("request a magic link ")
          ], undefined, true),
          _: 1
        })
      ]),
      (hasOtherOptions.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_10))
        : _createCommentVNode("", true),
      (_ctx.samlSsoUrl)
        ? (_openBlock(), _createBlock(TransparentButton, {
            key: 2,
            class: "saml-login",
            text: _ctx.samlSsoName,
            click: onSamlSSO
          }, null, 8, ["text"]))
        : _createCommentVNode("", true),
      _createVNode(AppVersion, { class: "app-v" })
    ])
  ]))
}
}

})